import { Component, Host, h } from '@stencil/core';

@Component({
  tag: 'presto-stacked-skin',
  styleUrl: 'presto-stacked-skin.scss',
  shadow: false,
})
export class PrestoStackedSkin {
  render() {
    return (
      <Host>
        <slot></slot>
      </Host>
    );
  }
}
